import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AuditLogSchema = withDefaults({
  type: 'audit-log',
  fields: [
    {
      kind: 'attribute',
      name: 'auditQueueId',
    },
    {
      kind: 'attribute',
      name: 'actionType',
    },
    {
      kind: 'attribute',
      name: 'escalationRequested',
    },
    {
      kind: 'attribute',
      name: 'correctAction',
    },
    {
      kind: 'attribute',
      name: 'correctAmountCents',
    },
    {
      kind: 'attribute',
      name: 'correctionApplied',
    },
    {
      kind: 'attribute',
      name: 'correctionBlockedReason',
    },
    {
      kind: 'attribute',
      name: 'messageCorrection',
    },
    {
      kind: 'attribute',
      name: 'auditorNote',
    },
    {
      kind: 'attribute',
      name: 'employeeNote',
    },
    {
      kind: 'attribute',
      name: 'robotAmountOverpaidCents',
    },
    {
      kind: 'attribute',
      name: 'robotAmountUnderpaidCents',
    },
    {
      kind: 'attribute',
      name: 'personAmountOverpaidCents',
    },
    {
      kind: 'attribute',
      name: 'personAmountUnderpaidCents',
    },
    {
      kind: 'attribute',
      name: 'auditorName',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
  ],
});

export default AuditLogSchema;
